export default {
  sorry: 'Lamentamos',
  sorryClass: 'Pedimos desculpa, mas não conseguimos encontrar',
  weFound: 'não encontrámos ',
  noResults: 'quaisquer resultados',
  fares: ' tarifas',
  theseDates: ' nestas datas.',
  matchingSearch: 'correspondentes à sua pesquisa.',
}
